import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { ConsumidorModel, ConsumidorFormatter, ConsumidorService } from '../shared';
import { LoginService } from "../shared/login.service";

import { DadosGovBr } from "../../../shared/model/dados-gov-br.model";


import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import {
  MaskManager, CPFValidator, ConfiguracoesProjeto, ParametrosService, NbpInfoComponent,
  NbpConfirmComponent
} from '../../../shared';
import { SessionStorageSorteio } from '../../../publico/sorteios/shared/session-storage-sorteio';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { RecaptchaSafety } from '../../../shared/security/RecaptchaSafety';
import { CidadaoLgpd } from '../consumidor-lgpd/cidadao-lgpd';
import { StorageManagementPortal } from "../shared/storage-management-portal";
import { GerenciadorCookieSvaut } from "../../../shared/svaut/gerenciador-cookie-svaut";


@Component({
  selector: 'app-consumidor-login-gov-br',
  templateUrl: './consumidor-login-gov-br.component.html',
  styleUrls: []
})
export class ConsumidorLoginGovBrComponent implements OnInit {
    
    public dadosGovBr: DadosGovBr | null = null;
    public errorMessage: string | null = null;

    public configuracao: ConfiguracoesProjeto;

    public consumidor: ConsumidorModel;
    
    public msgErroLogin = '';
    public mensagemModalImpedido: string = null;

    constructor(private readonly router: Router,
                private readonly route: ActivatedRoute,
                private readonly loginService: LoginService,
                private readonly sessionStorageSorteio: SessionStorageSorteio,
                private readonly ngbModalService: NgbModal,
                private readonly consumidorService: ConsumidorService,
              private readonly parametrosService: ParametrosService) { }

    ngOnInit(): void {

        this.consumidor = new ConsumidorModel();
        this.consumidorService.setEditMode(false);
        this.loginService.logout();

        const dataBase64 = this.route.snapshot.queryParamMap.get('data');

        if (dataBase64) {

        try {
            // Remove quebras de linha ou espaços extras
            const dataClean = decodeURIComponent(dataBase64).replace(/(\r\n|\n|\r)/gm, '');
            const decoded = atob(dataClean);

            this.dadosGovBr = JSON.parse(decoded) as DadosGovBr;
            this.consumidor.cpf = ConsumidorFormatter.formataString(this.dadosGovBr.dadosUsuario.cpf);
            this.consumidor.senha = null;
            this.consumidor.token = this.dadosGovBr.dadosUsuario.token || '';

            this.redirecionaUsuario(this.consumidor.cpf);

        } catch (error) {   

             // Apresenta a mensagem de erro para o usuário.
            let erro = error as StatusRequisicao;
            this.errorMessage = error.motivo;
        }
        } else {        
             this.errorMessage = 'Parâmetro "data" não encontrado na URL.';
        }

        // OBSERVADOR QUE AGUARDA O RETORNO DO LOGIN DO USUARIO, REDIRECIONA OU CARREGA OS DADOS DO USUARIO NO LOCALSTORAGE
    this.loginService.loginAutorized
      .subscribe(
      (data) => {
        if (data.logado) {

          this.consumidorService.setEditMode(true);

            if(CidadaoLgpd.TermoLgpdAceito()) {

              this.msgErroLogin = '';
              this.sessionStorageSorteio.DefinirSessionStoragePeriodoSorteioMensalAtual();

              this.router.navigate(['consumidor/detalhar']);

              if (this.mensagemModalImpedido) {
                const confirmModal = this.ngbModalService.open(NbpInfoComponent);
                confirmModal.componentInstance.info = this.mensagemModalImpedido;
              }

          }else{
                this.router.navigate(['consumidor/termo-lgpd']);
          }

        } else {

          this.consumidorService.setEditMode(false);
          this.msgErroLogin = data.mensagem;
          this.mensagemModalImpedido = null;
        }
      }
      );
    }

    redirecionaUsuario(cpfLogin: string) {
        const cpf = Number(cpfLogin.replace(/\.|\-|\_/g, ''));  
    
        this.consumidorService.getSituacaoCadastroCPF(cpf).subscribe(
        (data) => {          
          switch (+data) {
            case 0: // Indeterninado
                this.DefinirApresentacaoRedirecionamentoCidadaoIndeterminado();
                this.redirecionarParaTelaInicial();
                break;            
            case 4: // Bloqueado
                this.DefinirApresentacaoRedirecionamentoCidadaoBloqueado();
                this.redirecionarParaTelaInicial();         
                break;
            case 5: // Excluído
                this.DefinirApresentacaoRedirecionamentoCidadaoExcluido();
                this.redirecionarParaTelaCadastramento();         
                break;
            case 7: // Inexistente
                this.DefinirApresentacaoRedirecionamentoCidadaoInexistente();
                this.redirecionarParaTelaCadastramento();          
                break;
            default: // Válido        
                this.loginService.loginToken(this.consumidor);                              
          }
        }, error => {

          // Apresenta a mensagem de erro para o usuário.
            let erro = error as StatusRequisicao;
            this.errorMessage = error.motivo;
          });
    }
  
          private redirecionarParaTelaCadastramento() {        
            GerenciadorCookieSvaut.LimparCookieRedirecionamento();
            GerenciadorCookieSvaut.DefinirCookieRedirecionamento(this.urlCadastroPortal);
          
             new StorageManagementPortal(this.parametrosService).RealizarRedirecionamentoLogoutSvaut();
          }

         private redirecionarParaTelaInicial() {        
            GerenciadorCookieSvaut.LimparCookieRedirecionamento();
            GerenciadorCookieSvaut.DefinirCookieRedirecionamento(this.urlInicioPortal);
          
            new StorageManagementPortal(this.parametrosService).RealizarRedirecionamentoLogoutSvaut();
          }

          public get urlInicioPortal () {
              this.configuracao = this.parametrosService.getConfiguracao();
              return this.configuracao.url_inicio_portal_frontend;     
          }

          public get urlCadastroPortal () {
              this.configuracao = this.parametrosService.getConfiguracao();
              return this.configuracao.url_cadastro_portal_frontend;     
          }

          private DefinirApresentacaoRedirecionamentoCidadaoIndeterminado() {
                localStorage.setItem('redirecionamento_cidadao_indeterminado_logout_gov_br_inicio', "1");
                localStorage.setItem('redirecionamento_cidadao_bloqueado_logout_gov_br_inicio', "0");
                localStorage.setItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro', "0");
                localStorage.setItem('redirecionamento_cidadao_excluido_logout_gov_br_inicio', "0");
          }

          private DefinirApresentacaoRedirecionamentoCidadaoBloqueado() {
                localStorage.setItem('redirecionamento_cidadao_indeterminado_logout_gov_br_inicio', "0");
                localStorage.setItem('redirecionamento_cidadao_bloqueado_logout_gov_br_inicio', "1");
                localStorage.setItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro', "0");
                localStorage.setItem('redirecionamento_cidadao_excluido_logout_gov_br_inicio', "0");
          }

           private DefinirApresentacaoRedirecionamentoCidadaoInexistente() {
                localStorage.setItem('redirecionamento_cidadao_indeterminado_logout_gov_br_inicio', "0");
                localStorage.setItem('redirecionamento_cidadao_bloqueado_logout_gov_br_inicio', "0");
                localStorage.setItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro', "1");
                localStorage.setItem('redirecionamento_cidadao_excluido_logout_gov_br_inicio', "0");
          }

          private DefinirApresentacaoRedirecionamentoCidadaoExcluido() {
               localStorage.setItem('redirecionamento_cidadao_indeterminado_logout_gov_br_inicio', "0");
               localStorage.setItem('redirecionamento_cidadao_bloqueado_logout_gov_br_inicio', "0");
               localStorage.setItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro', "0");
               localStorage.setItem('redirecionamento_cidadao_excluido_logout_gov_br_inicio', "1");
          }
}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-login-gov-br/consumidor-login-gov-br.component.ts